import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { AppConfig } from '../../shared/app.config';

@Component({
    selector: 'page-imprint',
    templateUrl: 'imprint.html'
})
export class ImprintPage {
    appInfo: object;

    constructor(public navCtrl: NavController, public navParams: NavParams, public appConfig: AppConfig) {
        this.appInfo = appConfig.getAppInfo(); //Retrieves app info from config file
    }
}



// WEBPACK FOOTER //
// ./src/pages/imprint/imprint.ts